import { useEffect } from 'react';

export function useOutsideAlerter(ref, toCallFunction) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        toCallFunction();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}

export function useMouseLeave(ref, toCallFunction) {
  useEffect(() => {
    const handleMouseLeave = event => {
      if (ref.current && !ref.current.contains(event.relatedTarget)) {
        toCallFunction();
      }
    };

    const node = ref.current;
    if (node) {
      node.addEventListener('mouseleave', handleMouseLeave);
    }

    return () => {
      if (node) {
        node.removeEventListener('mouseleave', handleMouseLeave);
      }
    };
  }, [ref, toCallFunction]);
}
